export class Environment {
  static create() {
    return new Environment()
  }

  isNode() {
    return typeof window === 'undefined'
  }

  isBrowser() {
    return typeof window !== 'undefined'
  }
}
